<template>
    <div id="app">
        <section class="banner-area relative">
            <div class="container">
                <div class="row d-flex align-items-center justify-content-center">
                    <div class="about-content col-lg-12">
                        <h1 class="text-white">
                            Send Message
                        </h1>
                        <p>It's time to post a blog {{this.firstname}} {{this.lastname}}</p>
                        <div class="link-nav">
                            <span class="box">
                                <router-link to="/main">Zark Academy</router-link>
                                <i class="lnr lnr-arrow-right"></i>
                                <router-link to="">Profile Info</router-link>

                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rocket-img">
                <img src="../assets/img/rocket.png" alt="">
            </div>
        </section>
        <br><br>
        <div class="container">
            <div class="row dicusssec">
                <div class="col-md-4">
                    <div class="textBoxSection">
                        <label>Write your Message</label><br>
                        <textarea type="text" v-model="comment" class="form-control"  :class="{
                            'is-invalid': $v.description.$error, 'is-valid': !$v.description.$invalid
                        }" placeholder="Message" v-on:keyup.enter="postMessage"></textarea>
                    </div>
                    <br><br>
                    <div class="imageUploadSection">
                        <label>Upload an Image!</label><br>
                        <div class="input-group"> 
                            <input type="file" id="imageFile" v-on:change="OnChangeFile"><br><br>
                            <div class="spinner-grow text-muted" v-show="uploadStatus">.........Uploading</div>
                        </div>
                        <div v-if="imageUrlValidation">
                            <div class="alert alert-success">{{this.imageUrlMessage}}</div>
                        </div>
                        <div v-else>
                            <div class="alert alert-warning">{{this.imageUrlMessage}}</div>
                        </div>
                        <div class="cancelImage" v-if="showCancelButton">
                            <button v-on:click="cancelImage">Cancel</button>
                            <img :src="this.previewUrl"  style="width:100%; height:250px">
                        </div>
                    </div>
                    <div class="postButton">
                        <button type="submit" v-on:click="postMessage" class="primary-btn">POST</button>
                    </div>
                </div>
                <br><br>
                <div class="col-md-8 msgsec">
                    <div class="messageSection"
                    v-for="(post,index) in messages.data.slice(0,messageCount)"
                    v-bind:item="post"
                    v-bind:index="index"
                    v-bind:key="post.id"
                    >
                        <div class="userDetails">
                            <div class="usernameSection">
                            <router-link class="nav-link" :to="{name: 'UserBlog', params: {id: post.userid}}"> <label>{{post.firstname}} {{post.lastname}}</label> </router-link>
                            </div>
                            <div class="timeSection">
                                <label>{{post.commentedTime}}</label>
                            </div>
                        </div>
                        <div class="jumbotron">
                            <div class="imageSection" v-if="post.imageURL">
                                <img :src="post.imageURL" style="height:250px">
                            </div>
                            <span>{{post.comment}}</span>
                        </div>
                        <div class="deleteButton" v-if="post.userid === id">
                            <button class="btn btn-danger" v-on:click="deletPost(post.id)">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br><br>
    </div>
    
    
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
import PostService from '../PostService';
import firebase from 'firebase';
import "firebase/auth";
export default {
    name:'DiscussionCentre',
    data(){
        return{
            uploadStatus:false,
            imageUrlMessage: "Image has'nt selected yet!",
            imageUrlValidation: true,
            id:"",
            firstname:"",
            lastname:"",
            comment:"",
            imageURL:"",
            error:"",
            messages:[],
            messageCount : 20,
            fileData: '',
            fileName: '',
            fileType:'',
            fileSize:'',
            showCancelButton:false
        }
    },
    created(){
        this.getMessages()
    },
    validations: {
        description: {
            maxLength: maxLength(255)
        },
    },
    methods:{
        loadMessages(){
            this.messageCount = this.messageCount +5
        },
        async getMessages(){
            await firebase.auth().onAuthStateChanged(user => {
                this.id = user.uid;
            });
            try{
                var response = await PostService.userAccountInfo(this.id);
                this.firstname=response.data.firstname;
                this.lastname=response.data.lastname;
            } catch(err){
                this.error=err.message;
            }
            firebase.firestore().collection('chat').doc(this.id).collection(this.$route.params.id).orderBy('createdAt','desc').onSnapshot(this.onMessage);
        },
        async onMessage(){
            try{
                var data={
                    ownerid :this.id,
                    recepientid:this.$route.params.id,
                }
                this.messages = await PostService.getIndividualUserChat(data);
            } catch(err){
                this.error=err.message;
            }
        },
        async OnChangeFile(event){
            this.fileData = event.target.files[0]  
            this.fileName = this.fileData.name;
            this.fileSize = this.fileData.size;  
            this.fileType = this.fileData.type;
            var File_Size = this.fileSize;
            var File_Type = this.fileType;
            var MB =  File_Size / 1024 / 1024;
            if(File_Type=="image/jpeg" || File_Type=="image/png"){
                if(MB < 5){
                    this.imageUrlMessage="Your image is Valid!";
                    this.imageUrlValidation=true;
                    this.showCancelButton=true
                }else{
                    this.imageUrlMessage="File size exceed the 10mb limit";
                    this.imageUrlValidation=false;
                }
            }
            else{
                this.imageUrlMessage="File Format Must be of type PNG or JPEG";
                this.imageUrlValidation=false;
            }
            console.log('changed')
        },
        async cancelImage(){
            this.fileData =''
            this.fileName = ''
            this.fileSize = ''  
            this.fileType = ''
            document.querySelector('#imageFile').value =''
            this.showCancelButton=false
        },
        async postMessage(){
            this.$v.$touch()
            if(this.$v.$invalid || !this.imageUrlValidation){
                alert('Something went Wrong!')
            } else{
                this.uploadStatus=true;
                if(this.fileName!=''){
                const store = firebase.storage();
                var storageRef = store.ref('photos/' + this.fileName);
                    await storageRef.put(this.fileData)
                    .then(snapshot => {
                        return snapshot.ref.getDownloadURL();   // Will return a promise with the download link
                    })
                    .then(downloadURL => {
                        this.imageURL = `${downloadURL}`;
                        this.uploadStatus=false;
                        this.imageUrlMessage="Your Pic Is Valid!";
                        this.imageUrlValidation=true;
                        //Successfully uploaded file and got download link
                        return downloadURL;
                    })
                    .catch(error => {
                        this.uploadStatus=false;
                        this.imageUrlMessage="Something Wrong Happend Please Try Again";
                        this.imageUrlValidation=false;
                        // Use to signal error if something goes wrong.
                        this.error=`${error}`;
                    });
                }
                var data = {
                    senderId: this.id,
                    receiverId: this.$route.params.id,
                    firstname: this.firstname,
                    lastname: this.lastname,
                    comment: this.comment,
                    imageURL: this.imageURL,
                    createdAt: new Date(),
                }
                await PostService.postIndividualUserChat(data);
                this.uploadStatus=false;
                this.comment=""
                this.fileName=''
                this.imageURL=''
            }
        },
        async deletPost(id){
            var data = {
                senderId: this.id,
                receiverId: this.$route.params.id,
                documentId: id
            }
            await PostService.deleteIndividualChatMessage(data);
            this.getMessages();
        }
    }
}
</script>

<style scoped>
@import '../assets/login.css';

.commentSection{
    display: grid;
    grid-template-columns: 60% 20% 20%;
    padding: 1em 0em;
    position: fixed;
    top: 4.5em;
    background-color: lavender;
    width: 100%;
    z-index: 100;
}
.textBoxSection{
    color: #000;
}

.imageUploadSection {
    color: #000;
}

.allMessages{
    margin-top: 15em;
}

.usernameSection label{
    color: black;
}

.msgsec {
    overflow-y: scroll;
    max-height: 500px;
}
.dicusssec {
    background: -webkit-linear-gradient(left, #3931af, #00c6ff);
    border-radius: 20px;
    padding: 10px;
}
.nav-link {
    padding: 0em;
}

.jumbotron{
    padding:0.5em 2em;
}

.deleteButton{
    float:right;
}

.loadMore{
    color:blue;
    cursor: pointer;
    text-align: center;
    padding: 1em 0em;
}
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey; 
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #000; 
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #1a1919; 
}


</style>